
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { priceRulesEl } from "@common/src/utils/verify";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { addCurrencyUnit } from "@common/src/utils/tools";
import t from "@common/src/i18n/t";

const base = namespace("base");
const marketing = namespace("marketing");
const setting = namespace("setting");
const app = namespace("app");

@Component({})
export default class ReturnCard extends Vue {
  @base.Action getDictionaryList;
  @marketing.Action queryCardDetail;
  @setting.Action getPatternPaymentList;
  @marketing.Action updateCardStatusRefund;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  t = t;
  groupIndex: number = 1;
  detailData: any = {
    operateList: []
  };
  payWayList: any = [];
  showRefundModal: boolean = false;
  recommendReturnAmount: string = "";
  @Prop({ type: String })
  cardCode;
  get orderId() {
    return this.$route.params.id || this.cardCode;
  }
  refundForm: any = {
    cardCode: "",
    returnAmount: "0",
    returnMethod: "",
    returnRemark: ""
  };
  checkPrice(rule, value, callback) {
    priceRulesEl(value, callback);
  }
  refundFormRule: any = {
    returnAmount: [
      { required: true, message: t("v210906.please-enter-the-actual-refund-amount"), trigger: "blur" },
      { validator: this.checkPrice, trigger: "blur" }
    ],
    returnRemark: { required: true, message: t("v210831.please-enter-refund"), trigger: "blur" },
    returnMethod: { required: true, message: t("finance.select-mode-payment"), trigger: "change" }
  };
  showRefundModalFn() {
    this.showRefundModal = true;
    this.refundForm.returnMethod = "";
    this.refundForm.returnRemark = "";
    this.$nextTick(() => {
      (this.$refs.refundForm as any).clearValidate();
    });
    this.init();
  }
  // 实际剩余金额（开发金额减去已使用账面金额）
  actualReturnAmount: number = 0;
  handleShowRefund() {
    console.log("[  ]", this.detailData);
    if (this.detailData.cardType === 1) {
      if (Number(this.detailData.cardAmount) > 0 && Number(this.detailData.carryingAmount) > 0) {
        this.refundForm.returnAmount = this.recommendReturnAmount = (
          this.detailData.carryingBalance *
          (this.detailData.cardAmount / this.detailData.carryingAmount) *
          0.8
        ).i18nToFixed();
      } else if (Number(this.detailData.carryingAmount) === 0) {
        // 账面金额为0
        this.refundForm.returnAmount = this.recommendReturnAmount = "";
      } else {
        this.refundForm.returnAmount = this.recommendReturnAmount = "0.00";
      }
    } else {
      // 储值卡实际剩余金额（开发金额减去已使用账面金额）
      this.actualReturnAmount = Number(
        (
          Number(this.detailData.cardAmount) -
          (Number(this.detailData.carryingAmount) - Number(this.detailData.carryingBalance))
        ).i18nToFixed()
      );
      if (this.actualReturnAmount <= 0) {
        this.refundForm.returnAmount = this.recommendReturnAmount = "0.00";
      } else {
        this.refundForm.returnAmount = this.recommendReturnAmount = (this.actualReturnAmount * 0.8).i18nToFixed();
      }
    }
    this.refundForm.cardCode = this.orderId;
  }
  init() {
    this.btnStartLoading();
    this.queryCardDetail({
      cardCode: this.orderId
    })
      .then(data => {
        data = data.data || {};
        if (data.cardType === 1) {
          data.serviceList &&
            data.serviceList.forEach(serviceItem => {
              if (serviceItem.partsList && serviceItem.partsList.length > 0) {
                serviceItem.isGroup = true;
                serviceItem.groupServiceIndex = this.groupIndex;
                serviceItem.partsList.forEach(partsItem => {
                  data.partsList.push(
                    Object.assign(partsItem, {
                      isGroup: true,
                      groupServiceIndex: this.groupIndex
                    })
                  );
                });
                this.groupIndex++;
              }
            });
        }
        this.detailData = data;
        this.handleShowRefund();
      })
      .finally(() => {
        this.btnStopLoading();
      });
    this.getPatternPaymentList({
      status: "1"
    }).then(data => {
      this.payWayList = this.$safeValue(data, "data", []);
    });
  }
  handleconfirmRefund() {
    (this.$refs.refundForm as any).validate(valid => {
      if (valid) {
        this.btnStartLoading();
        this.updateCardStatusRefund(this.refundForm)
          .then(() => {
            this.$message.success(t("v260.card-returned-successfully"));
            this.$emit("returnCardSuccess");
          })
          .finally(() => {
            this.showRefundModal = false;
            this.btnStopLoading();
          });
      }
    });
  }
}
